import { render, staticRenderFns } from "./Director.vue?vue&type=template&id=65b9481f&scoped=true&"
import script from "./Director.vue?vue&type=script&lang=js&"
export * from "./Director.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9481f",
  null
  
)

export default component.exports